import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// function loadLocaleMessages () {
//   const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
//   const messages = {}
//   locales.keys().forEach(key => {
//     const matched = key.match(/([A-Za-z0-9-_]+)\./i)
//     if (matched && matched.length > 1) {
//       const locale = matched[1]
//       messages[locale] = locales(key)
//     }
//   })
//   return messages
// }

// export default new VueI18n({
//   locale: process.env.VUE_APP_I18N_LOCALE || 'en',
//   fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
//   messages: loadLocaleMessages()
// })



const messages = {

    'pt':{
            name                   : "Nome"
            ,email                  : "E-mail"
            ,password               : "Senha"
            ,pwd_current            : "Senha Atual"
            ,pwd_new                : "Nova Senha"
            ,new_register           : "Novo cadastro"
            ,confirm_password       : "Confirmar Senha"
            ,change_password        : "Mudar Senha"
            ,forgot_password        : "Esqueci minha senha"
            ,delete_account         : "Excluir conta"
            ,contact                : "Contato"
            ,signup                 : "Cadastre-se"
            ,admin                  : "Administrador"
            ,user                   : "Usuário"
            ,login                  : "Login"
            ,enter                  : "ENTRAR"
            ,favorite_searchs       : "Buscas Favoritas"
            ,favorite_searchs_info  : "Edite suas buscas e crie alertas para receber atualizações dos decretos presidenciais sobre seus temas de preferência."
            ,alerts                 : "Alertas"
            ,logout                 : "Sair"

            ,placeholder_search     : "Busca: Digite texto de busca ou número do decreto"
            ,result_search          : " Resultado"
            ,result_search_plural   : "s"
            ,result_search2         : "Termo(s) pesquisado(s): "

            ,"emailSent"            : "E-mail enviado com sucesso"
            ,"auth/user-not-found"  : "O E-mail informado não foi encontrado na base de dados do ATOS."
            ,"auth/invalid-email"   : "O E-mail informado não possui um formato válido."

            ,errorLoginEmail        : "E-mail inválido ou inexistente."
            ,errorLoginPwd          : "Senha inválida ou inexistente."


            ,act                    : "Ato" 
            ,publicationDate        : "Data Publicação"
            ,signatureDate          : "Data da Assinatura"
            ,shortdescriptionAct    : "Descrição"

            ,novocadastro           : "Cadastre-se e tenha acesso a recursos exclusivos"

            ,btn_send_email         : "Enviar"
            ,btn_change             : "Confirmar mudança de Senha"
            ,btn_registrarse        : "Confirmar cadastro"
            ,btn_delete_account     : "Confirmar exclusão da conta"
            ,btn_save               : "Salvar"


            ,message_error_invalid_email                : "É necessario informar um e-mail válido"
            ,message_error_invalid_email_and_pwd        : "É necessario informar um e-mail e uma senha válidos"
            ,message_error_fields                       : "É necessario informar os campos obrigatórios"
            ,message_error_doesnt_match_email_and_pwd   : "A senha e a Confirmação da senha não são iguais."
            ,message_successfully_sent_email            : "E-mail enviado com sucesso."
            ,account_created_succefully                 : "Conta criada com sucesso."

            ,message_successfully_pwd_changed           : "Senha Alterada com sucesso !"
            ,message_error_pwd_changed                  : "Houve um erro ao alterar a senha. Tente novamente!"

            ,message_successfully_delete_acccount       : "Conta excluída com sucesso !"
            ,message_error_delete_acccount              : "Erro ao deletar a conta. Tente novamente mais tarde."

            ,message_error_fields_contact               : "É necessario preencher os campos para enviar a mensagem."

            ,policyPrivacyAgree                         : "Concordo com as políticas de privacidade e termos."
            ,msgPolicyPrivacy                           : "É necessario concordar com os termos de política de privacidade localizado no final da página"       
            ,infoMsgpolicyPrivacyAgree                  : "É necessario concordar com os termos de política de privacidade"

            ,hello          : "Olá,"

            ,add            : "Inclusão"
            ,change         : "Alteração"
            ,remove         : "Remoção"

            ,decreto        : "Decreto"
            ,lei            : "Lei"
            ,portaria       : "Portaria"

            ,btn_access     : "Acesse"
            ,text_home1     : "Acompanhe atos normativos presidenciais em tempo real"
            ,text_home2     : "ou "  
            ,text_home21    : " para receber alertas em tempo real"

            ,tit_section1   : "Facilitamos o acompanhamento sobre o que muda a cada decreto presidencial"

            ,subtit_section1: "O que é?"
            ,text_section1  : `A Plataforma Atos é uma ferramenta desenvolvida para facilitar o monitoramento e acompanhamento dos decretos do Poder Executivo Federal pela sociedade. A partir da leitura do Diário Oficial da União (DOU), a ferramenta permite, de maneira rápida e fácil, a comparação entre decretos promulgados e decretos até então vigentes. Nesta sua primeira versão, será possível analisar os decretos presidenciais a partir de 2007.`

            ,text_section11 : `A ferramenta também conta com um sistema de alerta, que permite ao usuário receber avisos sobre decretos publicados que tiverem relação com áreas ou temas que forem de seu interesse. Além disso, a plataforma permite ao usuário verificar informações quantitativas sobre o número de decretos publicados desde 2007 a partir de palavras-chave.`

            ,subtit_section2: "Como a Plataforma Atos pode nos ajudar?"
            ,text_section2  : `Considerando o impacto que os atos normativos do Executivo Federal têm nas políticas públicas que definem
                            os nossos rumos como país e que afetam nossas vidas nas mais diferentes áreas, é fundamental ampliarmos a capacidade
                            de acompanhamento desses atos por parte de cidadãos, organizações não-governamentais, jornalistas, pesquisadores, etc.`

            ,text_section21 : `Esta ampliação da capacidade de controle social sobre os atos de governo permitirá também uma maior mobilização da sociedade, 
                            inclusive para que ela possa questionar tais atos quando estes ultrapassarem os seus limites legais estabelecidos pela Constituição.`
                            

            ,btn_access2        : "Acesse gratuitamente"

            ,btn_gobackSearch   : "Voltar para a busca"

            ,text_section3      : "ou cadastre-se para obter recursos personalizados como alertas por email realtime das mudanças e filtros exclusivos para visualizar dados quantitativos de alterações e históricos."

            ,tit_section4       : "Somos um instituto de pesquisa com foco na segurança e desenvolvimento social"
            ,text_section4      : `O Instituto Igarapé é um think and do tank independente, dedicado à integração das agendas de segurança, 
                                clima e desenvolvimento. Nosso objetivo é propor soluções a desafios globais por meio de pesquisas, 
                                novas tecnologias, comunicação, articulação de redes e incidência em políticas públicas. Somos uma instituição sem fins lucrativos, 
                                independente e apartidária, com sede no Rio de Janeiro, mas cuja atuação transcende fronteiras locais, nacionais e regionais. 
                                Premiada como a melhor ONG de Direitos Humanos no ano de 2018, o melhor think tank em política social pela Prospect Magazine 
                                em 2019 e considerada pelo Instituto Doar, pelo segundo ano consecutivo, como uma das 100 melhores organizações brasileiras do 
                                terceiro setor.`

            ,search             : " Buscar"
            ,e_ou               : " e ou"
            ,selectInitialDate  : " Selecione a data inicial"
            ,selectFinishDate   : " Selecione a data final"

            ,msgValidationSaveSearch                              : " É necessário estar logado para salvar a busca"
            ,msgValidationSearchedKw                              : " É necessário informar pelo menos uma palavra no campo de Busca"
            ,msgValidationSearchedKwLength                        : " É necessário informar um termo com pelo menos 3 caracteres."
            ,msgValidationSearchedKwRangeDate                     : " E necessário informar a Data Inicial e a Data Final."
            ,msgValidationSearchedKwRangeEndDateBeforeInitialDate : " A Data Final deve ser posterior a data Inicial."
            ,msgValidationSearchedKwRangeInitialDateAfterEndDate  : " A Data inicial deve ser anterior a data Final"

            ,msgValidationAlert   : "É necessario informar um termo no campo Palavras-chaves para salvar a Busca"
            ,msgValidationAlertOn : "Para ativar o alerta é necessario informar um nome para o alerta." 


            ,msgTitleWarning      : "Atenção"
            ,msgTitleInfo         : "ATOS"

            ,register             : "Cadastrar"
            ,update               : "Alterar"

            ,yes                  : "Sim"
            ,no                   : "Não"

            ,titleConfirmRegisterKeyword  : "Confirmar cadastro"
            ,msgConfirmRegisterKeyword    : "Deseja realmente cadastrar esta(s) palavra(s)-chave?"

            ,titleConfirmDeleteKeyword    : "Confirmar Remoção"
            ,msgConfirmDeleteKeyword      : "Deseja realmente apagar esta palavra-chave?"

            ,titleConfirmChangesKeyword   : "Confirmar Alteração"
            ,msgConfirmChangesKeyword     : "Deseja realmente alterar esta(s) palavra(s)-chave?"

            ,modificationsResume          : "Resumo das modificações: "
            ,infoModificationsResume      : "Verifique os decretos modificados pelo decreto selecionado. Ao clicar na modificação, acesse o texto original do decreto modificado pelo decreto selecionado."

            ,actFullText                  : "Texto na íntegra"
            ,infoActFullText              :"Acesse a íntegra do decreto selecionado."

            ,noData                       : "Não foi possível carregar os dados. Tente novamente mais tarde."

            ,noDataInfo                   : "Não existem dados disponíveis para o filtro selecionado."

            ,este                         :'Este '
            ,esta                         :'Esta '
            ,actRevoked                   :'{acttype} revogado pelo {acttype} {actNumber} em {actDate}.'
            ,actWithTextAdd               :'{acttype} possui um texto adicionado pelo <a href="{actNumber}" target="blank">{acttype} Nº{actNumber}</a> em {actDate}.'
            ,actWithTextChanged           :'{acttype} possui um texto modificado pelo <a href="{actNumber}" target="blank"> {acttype} Nº{actNumber}</a> em {actDate}.'
            ,actWithTextRemoved           :'{acttype} teve um texto removido pelo <a href="{actNumber}" target="blank"> {acttype} Nº {actNumber}</a> em {actDate}.'


            ,tu_title: "Termos de Uso"

            ,tu_paragraph1 : `As informações disponibilizadas pela plataforma ATOS são coletadas pelo Instituto Igarapé a partir de 
            leitura do Diário Oficial da União e do Portal da Legislação disponibilizado pelo Executivo Federal. A equipe responsável pela 
            plataforma empreende esforços frequentes para manter e aperfeiçoar suas funcionalidades.`

            ,tu_paragraph2 : `Como esta é uma versão beta da ferramenta, caso erros ou falhas sejam identificados, solicitamos a gentileza de nos informar 
            através do email: contato@igarape.org.br. Dessa maneira, será possível orientarmos nossos esforços para que a plataforma atenda cada 
            vez mais as necessidades de suas usuárias e de seus usuários.`

            ,tu_paragraph3 : `A plataforma ATOS armazena o Nome e o E-mail do usuário para ser usado na autenticação na plataforma 
            e possa receber os alertas por e-mail quando configurado pelo usuário .`

            ,tu_paragraph4 : `Esses dados são armazenados no Google Firebase, responsável pela autenticação do usuário. 
            Os termos do Firebase incluem Termos de segurança e processamento de dados para todos os serviços do Firebase, 
            com vigência a partir de 25 de maio de 2018. O Firebase é certificado de acordo com os principais padrões de privacidade e segurança.`

            ,tu_paragraph5: `A Plataforma não coleta, trata ou armazena nenhum outro dado pessoal durante a sua utilização, garantindo assim 
            a privacidade e o anonimato dos seus usuários. ` 

            ,faq_title: `Perguntas Frequentes`

            ,version: 'Versão'
            ,original:' original'
            ,current: " atual"
            ,versiongiven: 'dada pelo decreto N.º'
    }
    
};

const i18n = new VueI18n({
    locale: 'pt', // set locale    
    fallbackLocale: 'es', // set fallback locale   
    messages, // set locale messages
});

export default i18n;